var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticStrUndefined.js
// module id = 51
// module chunks = 106